import './index.css';
import './builder-settings';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import '@builder.io/widgets';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomepageFullHeadless } from './pages/HomepageFullHeadless';
import { Product } from './pages/Product';
import { Collection } from './pages/Collection';
import { CatchAll } from './pages/CatchAll';
import { Blocks } from './pages/Blocks';

const App = () => {
  const classes = useStyles();

  return (
    <Router>
      <Header />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
<link rel="manifest" href="/site.webmanifest" />
<link rel="mask-icon" href="/safari-pinned-tab.svg" color="#c4c4c4" />
<meta name="msapplication-TileColor" content="#da532c" />
<meta name="theme-color" content="#e4e4e4" />
      <div className={classes.container}>
        <Switch>
          <Route path="/homepage-full-headless">
            <HomepageFullHeadless />
          </Route>
          <Route path="/">
            <CatchAll />
          </Route>
        </Switch>
      </div>
    </Router>
  );
};

const useStyles = makeStyles(theme => ({
  link: {
    color: '#555',
    margin: '0 10px',
  },
  container: {
    minHeight: 'calc(100vh - 150px)',
  },
}));

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);
